import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "change-logs"
    }}>{`Change logs`}</h1>
    <h4 {...{
      "id": "v105--23-may-23"
    }}>{`v1.0.5 – 23 May 23`}</h4>
    <pre><code parentName="pre" {...{}}>{`- New: Multiple seasonl pricing range supported
`}</code></pre>
    <h4 {...{
      "id": "v104--30-dec-21"
    }}>{`v1.0.4 – 30 Dec 21`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Make it compatible with RnB 11.0.8
- Fixed issue of without time settings
`}</code></pre>
    <h4 {...{
      "id": "v103--26-november-21"
    }}>{`v1.0.3 – 26 November 21`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Make it compatible with RnB 11.0.7 
`}</code></pre>
    <h4 {...{
      "id": "v101--19-november-19"
    }}>{`v1.0.1 – 19 November 19`}</h4>
    <pre><code parentName="pre" {...{}}>{`- fix: validation issue
- update: Working with the latest RNB version 9.0.3
`}</code></pre>
    <h4 {...{
      "id": "v101--12-november-19"
    }}>{`v1.0.1 – 12 November 19`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Initial release
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      